import { apiGet } from "../baseApi";
import { setDistrictData } from "service/mapper";

export const getList = async ({params={}, config = {}}) => {
  try {
    const response = await apiGet("_district", params, null, config);
    return {
      ...response,
      rowData: (Array.isArray(response.data.districts) ? response.data.districts : []).map((el) => setDistrictData(el)),
    };
  } catch (error) {
    return Promise.reject(error);
  }
};
